import TablaConciliacion from "../../../TablaConciliacion";

function TablaAutoRioMagdalena() {
  return (
    <TablaConciliacion nombreUseCase="AUTOPISTARIOMAGDALENA" titulo="AUTOPISTA RIO MAGDALENA" />
  );
}

export default TablaAutoRioMagdalena;
